export default "__VITE_ASSET__ca685433__"